import { FormOption } from '../types';

export enum EducationLevel {
    primaryEducation = 'Basisonderwijs',
    secondaryEducation = 'Voortgezet onderwijs',
    mbo = 'MBO',
    higherEducation = 'Hoger onderwijs',
    other = 'Anders',
}

export enum EducationSubLevel {
    vmbo = 'VMBO',
    havo = 'HAVO',
    vwo = 'VWO',
    mbo1 = 'MBO 1',
    mbo2 = 'MBO 2',
    mbo3 = 'MBO 3',
    mbo4 = 'MBO 4',
    hbo = 'HBO',
    bachelor = 'Bachelor',
    masterPhD = 'Master of PhD',
}

export enum LearningPath {
    bbl = 'BBL',
    bol = 'BOL',
    other = 'Anders',
}

export const educationLevels = [
    EducationLevel.primaryEducation,
    EducationLevel.secondaryEducation,
    EducationLevel.mbo,
    EducationLevel.higherEducation,
    EducationLevel.other,
];

export const educationLevelsWithSubLevels = [EducationLevel.secondaryEducation, EducationLevel.mbo, EducationLevel.higherEducation];
export const educationLevelsWithLearningPaths = [EducationLevel.mbo];
export const educationLevelsWithFieldOfStudyOptions = [EducationLevel.mbo];

export const transformEducationLabelToFormOption = (label: string): FormOption => ({
    label,
    value: label,
});

export const educationLevelOptions = educationLevels.map(transformEducationLabelToFormOption);

export const educationSubLevelOptions: Record<EducationLevel, EducationSubLevel[]> = {
    [EducationLevel.primaryEducation]: [],
    [EducationLevel.secondaryEducation]: [
        EducationSubLevel.vmbo,
        EducationSubLevel.havo,
        EducationSubLevel.vwo,
    ],
    [EducationLevel.mbo]: [
        EducationSubLevel.mbo1,
        EducationSubLevel.mbo2,
        EducationSubLevel.mbo3,
        EducationSubLevel.mbo4,
    ],
    [EducationLevel.higherEducation]: [
        EducationSubLevel.hbo,
        EducationSubLevel.bachelor,
        EducationSubLevel.masterPhD,
    ],
    [EducationLevel.other]: [],
};

export const learningPathOptions: Record<EducationLevel, LearningPath[]> = {
    [EducationLevel.primaryEducation]: [],
    [EducationLevel.secondaryEducation]: [],
    [EducationLevel.mbo]: [
        LearningPath.bbl,
        LearningPath.bol,
        LearningPath.other,
    ],
    [EducationLevel.higherEducation]: [],
    [EducationLevel.other]: [],
};
